<div class="reject-modal">
  <div class="modal-body">
    <p class="lead">
      You are about to reject this application. Please provide a reason for the rejection to proceed.
    </p>

    <textarea rows="4" nz-input [(ngModel)]="reason" maxlength="4000" 
              placeholder="Please provide a reason for the rejection."></textarea>
  </div>

  <div class="modal-footer">
    <button nz-button nzType="default" (click)="cancel()">Cancel</button>
    <button nz-button class="btn-confirm" nzType="primary" (click)="onConfirm()" [disabled]="!reason">Confirm</button>
  </div>
</div>
